export const styles = (theme) => ({
  contextIconsFontSize:{
    fontSize:"19px",
  },
  contextIcons:{
    fontSize:"16px",
      marginRight: "10px",
  },
  buttons: {
    "& .noPermission":{
      margin:"0 !important",
    },
            boxShadow: "none",
            background: " #0C853E",
            border: "1px solid #0C853E",
            lineHeight: "31px",
            fontSize: "14px",
            minWidth: "30px",
            margin: "12px",
            padding: "0",
            height: "30px",
            borderRadius: "4px",
    
        "&:hover": {
          opacity: ".8",
          color: "#fff",
          background: " #0C853E",
        },
       "& svg":{
           fontSize:"11px",
       }
  },
  iconContext:{
    marginRight:"5px",
    fontSize: "16px",
  }
});


